
import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { WhatsAppButton } from '../../components/feature/WhatsAppButton';

const AboutPage: React.FC = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenilirlik',
      description: 'Tüm ilanlarımız detaylı kontrol edilir ve doğrulanır. Güvenli alım-satım için şeffaf bilgi sağlarız.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Müşteri Odaklı',
      description: '7/24 müşteri desteği ile her zaman yanınızdayız. Sorularınızı yanıtlıyor, süreçte size rehberlik ediyoruz.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Yenilikçi Çözümler',
      description: 'Modern teknoloji ile devremülk alım-satım sürecini kolaylaştırıyor, hızlı ve pratik çözümler sunuyoruz.',
    },
    {
      icon: 'ri-team-line',
      title: 'Uzman Ekip',
      description: 'Gayrimenkul ve devremülk konusunda deneyimli ekibimiz ile profesyonel hizmet veriyoruz.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#0A1628] to-[#1a2d4d]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Hakkımızda
          </h1>
          <p className="text-xl text-white/80 max-w-3xl">
            Türkiye'nin en güvenilir devremülk ilan platformu
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] mb-6">
                Hikayemiz
              </h2>
              <div className="space-y-4 text-lg text-[#6B7A90] leading-relaxed">
                <p>
                  Devremülk sektöründe yılların deneyimi ile yola çıktık. Amacımız, devremülk sahiplerinin 
                  haklarını güvenle satabilecekleri ve alıcıların doğru fırsatları bulabilecekleri bir platform oluşturmaktı.
                </p>
                <p>
                  Bugün, Türkiye'nin dört bir yanındaki prestijli tatil köylerinde binlerce devremülk ilanını 
                  bir araya getiriyoruz. Şeffaf bilgi, doğrulanmış ilanlar ve profesyonel destek ile sektörde 
                  güvenin adresi olduk.
                </p>
                <p>
                  Modern teknoloji ve kullanıcı dostu arayüzümüz ile devremülk alım-satım sürecini 
                  kolaylaştırıyor, her adımda yanınızda oluyoruz.
                </p>
              </div>
            </div>
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/fe277fdba9c935c1a2318e5d6eb2337f.jpg"
                alt="Ekibimiz"
                className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 bg-[#F7F9FC]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] text-center mb-16">
            Değerlerimiz
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 flex items-center justify-center bg-[#D4AF37]/10 rounded-2xl mb-6">
                  <i className={`${value.icon} text-3xl text-[#D4AF37]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#0A1628] mb-3">
                  {value.title}
                </h3>
                <p className="text-base text-[#6B7A90] leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeshare Solutions Section */}
      <section className="py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=luxury%20resort%20pool%20area%20aerial%20view%20turquoise%20water%20palm%20trees%20white%20sun%20loungers%20modern%20architecture%20mediterranean%20coast%20vacation%20paradise%20peaceful%20atmosphere%20sunny%20day&width=800&height=600&seq=about2&orientation=landscape"
                alt="Devremülk Çözümleri"
                className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
              />
            </div>
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] mb-6">
                Devremülk Çözümleri
              </h2>
              <div className="space-y-4 text-lg text-[#6B7A90] leading-relaxed">
                <p>
                  Devremülk sahipleri için satış sürecini kolaylaştırıyor, alıcılar için ise en uygun 
                  fırsatları bir araya getiriyoruz. Platform üzerinden:
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-2xl text-[#D4AF37] flex-shrink-0"></i>
                    <span>Tesis, lokasyon ve hafta sayısına göre detaylı filtreleme yapabilirsiniz</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-2xl text-[#D4AF37] flex-shrink-0"></i>
                    <span>Doğrulanmış ilanlar ile güvenli alım-satım gerçekleştirebilirsiniz</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-2xl text-[#D4AF37] flex-shrink-0"></i>
                    <span>WhatsApp ve telefon ile anında satıcılarla iletişime geçebilirsiniz</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-2xl text-[#D4AF37] flex-shrink-0"></i>
                    <span>Ücretsiz ilan vererek geniş alıcı kitlesine ulaşabilirsiniz</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-[#0A1628]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Devremülk Arayışınıza Hemen Başlayın
          </h2>
          <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
            Türkiye'nin en prestijli tatil köylerinde binlerce devremülk ilanı sizi bekliyor
          </p>
          <Link to="/ilanlar">
            <button className="px-8 py-4 bg-[#D4AF37] text-white font-semibold rounded-xl hover:bg-[#B8961F] transition-colors text-lg whitespace-nowrap cursor-pointer">
              İlanları İncele
            </button>
          </Link>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default AboutPage;
